<template>
	<AppDialog v-model="isOpen">
		<div class="tw-rounded-lg tw-p-4" style="width: 600px">
			<div class="tw-pb-4">
				<div class="tw-text-lg tw-font-semibold">
					{{ $t('integrations.exporting-noon-catalog') }}
				</div>
				<div class="tw-text-gray-600">
					{{
						live
							? $t('integrations.how-to-export-my-live-catalog')
							: $t('integrations.how-to-export-my-not-live-catalog')
					}}
				</div>
			</div>

			<ol
				class="tw-flex tw-flex-col tw-gap-4 tw-px-4"
				type="1"
				start="1"
				style="list-style: decimal"
			>
				<li class="tw-border-b tw-border-b-gray-300 tw-pb-4">
					<div class="tw-flex tw-items-center">
						<span>{{ $t('integrations.visit-noon-seller-lab') }}</span>
						<a
							class="tw-cursor-pointer tw-ps-1 tw-text-blue-500 tw-underline hover:tw-underline"
							href="https://noon-catalog.noon.partners/ar/exports"
							>{{ $t('integrations.here') }}</a
						>
					</div>
				</li>
				<li class="tw-border-b tw-border-b-gray-300 tw-pb-4">
					<div class="tw-flex tw-flex-col">
						<div>{{ $t('integrations.after-logging-into-account-you-should-find') }}</div>
						<AppImage
							:src="loadFile('assets/v2/image/noon-integration/noon-help-exporting-1.png')"
							width="550px"
							class="tw-rounded-lg"
						/>
					</div>
				</li>
				<li class="tw-border-b tw-border-b-gray-300 tw-pb-4">
					<div class="tw-flex tw-flex-col">
						<div>{{ $t('integrations.click-download-button-similar-to-image') }}</div>
						<AppImage
							:src="loadFile('assets/v2/image/noon-integration/noon-help-exporting-2.png')"
							width="550px"
							class="tw-rounded-lg"
						/>
					</div>
				</li>
				<li class="tw-border-b tw-border-b-gray-300 tw-pb-4">
					<div class="tw-flex tw-flex-col">
						<div>{{ $t('integrations.you-should-see-similar-to-image') }}</div>
						<ul>
							<li>{{ $t('integrations.choose-catalog-as-export-type') }}</li>
							<li>{{ $t('integrations.followed-by-partner-catalog-as-subtype') }}</li>
							<li>
								{{
									live
										? $t('integrations.set-status-to-live-to-download-live-products')
										: $t('integrations.set-status-to-not-live-to-download-live-products')
								}}
							</li>
							<li>{{ $t('integrations.click-request-export-and-download') }}</li>
						</ul>
						<AppImage
							:src="loadFile('assets/v2/image/noon-integration/noon-help-exporting-3.png')"
							width="550px"
							class="tw-rounded-lg"
						/>
					</div>
				</li>
			</ol>

			<div class="tw-mt-4 tw-flex tw-justify-end">
				<AppButton :label="$t('close')" variant="gray" secondary @click="isOpen = false" />
			</div>
		</div>
	</AppDialog>
</template>

<script setup>
import AppDialog from '@/v2/components/dialog.vue';
import { ref } from 'vue';
import { loadFile } from '@/v2/utils/index';

const isOpen = ref(false);
const live = ref(false);

const open = (_live) => {
	live.value = _live;
	isOpen.value = true;
};

defineExpose({
	open,
});
</script>

<style lang="scss" scoped></style>
